
    import { computed, defineComponent, getCurrentInstance, ref } from 'vue'
    import useRouter from '@/hooks/useRouter'
    import { useProject } from '@/hooks/useProject'
    import { sortProjectsByName } from '@/utils'

    export default defineComponent({
        props: {
            items: {
                type: Array,
                default: () => []
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        emits: ['input', 'create', 'open'],
        setup(props, { emit }) {
            const root = getCurrentInstance()!.proxy
            const router = useRouter(root)
            const { project } = useProject()
            const isOpen = ref(false)

            const sortedItems = computed(() =>
                sortProjectsByName((props.items || []) as Array<{ name?: unknown; value?: string }>)
            )

            const toggleDropdown = () => {
                isOpen.value = !isOpen.value
                if (isOpen.value) {
                    emit('open')
                }
            }

            const selectItem = (item: any) => {
                isOpen.value = false
                const currentId = project.value.id
                const currentRoute = router.route.value.fullPath
                const newRoute = currentRoute.replace(currentId, item.value)
                router.router.push(newRoute).then(() => window.location.reload());
            }

            const createNewProject = () => {
                isOpen.value = false
                emit('create')
            }

            return {
                isOpen,
                sortedItems,
                toggleDropdown,
                selectItem,
                createNewProject,
            }
        }
    })
